//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from '~/components/page/SPage.vue'
import Card from '~/components/articles/Card.vue'
import CardLoading from '~/components/articles/CardLoading.vue'
import Article from '~/components/articles/Article.vue'
import CardMax from '~/components/articles/CardMax.vue'
import Pagination from '~/components/Pagination.vue'

export default {

  head: function () {

    return {
      title: this?.article?.seo_title || `Aкция: ${this?.article?.title} - Очки Для Вас`,
      meta: [
        {
          hid: 'metadescription',
          name: 'description',
          content: this?.article?.seo_description || `${this?.article?.title} в салонах сети оптик Очки Для Вас. ${this?.article?.description}`
        },
        {
          name: 'keywords',
          content: this?.article?.seo_keywords
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://linza.ru/storage/0_logo-linza_fc99a32e.svg',
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content: 'Очки Для Вас',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://${this.host}${this.$route.fullPath}`,
        }
      ],
    }
  },

  async asyncData (props) {
    const {
      params,
      query,
      $api,
      $router,
      error,
      req
    } = props
    const host = req?.headers?.host || window?.location.host || ''
    // Получение списка статей
    const {
      data: articles,
      headers
    } = await $api.agent.transport.get(`promotions?${(Object.keys(query).map((key) => {
      return `${key}=${query[key]}`
    })).join('&')}`).catch((err) => {
      return { data: { isError: true } }
    })
    if (articles.isError) {
      error({ statusCode: 404 })

      return null
    }

    // Получение статьи по SLUG
    const { data: article } = await $api.agent.transport.get(`promotions/${params.slug}?expand=category`).catch((err) => {
      return { data: { isError: true } }
    })
    if (article.isError) {
      error({ statusCode: 404 })

      return null
    }

    // Устоновка пагинации по данным из API
    const pagination = {
      page: Number(headers['x-pagination-current-page']),
      perPage: Number(headers['x-pagination-per-page']),
      pageCount: Number(headers['x-pagination-page-count']),
      totalCount: Number(headers['x-pagination-total-count']),
    }

    return {
      articles,
      pagination,
      host,
      article: {
        ...article,
        apiRoute: 'promotions',
        category: { categoryName: 'Акция' },
      }
    }
  },

  data: function () {
    return {
      breadcrumbs: [
        {
          path: '/',
          title: 'Главная'
        },
        {
          path: '/aktsii',
          title: 'Акции'
        },
      ],

      isLoading: true // Загрузка списка статей
    }
  },

  components: {
    Card,
    SPage,
    CardMax,
    Article,
    Pagination,
    CardLoading
  },

  mounted () {
    this.isLoading = false
  },

  computed: {
    sPageTitle: function () {
      return this?.article?.title || 'Акции'
    }
  },

  methods: {

    // Определение размера статии от ее порядка
    getClassGrid: function (idx) {
      if (idx > 5) {
        idx = idx - Math.floor(idx / 6) * 6
      }

      if ((idx + 1) % 6 === 0) {
        return 'col-span-3'
      }
      if ((idx + 1) % 5 === 0) {
        return 'col-span-3'
      }
      if ((idx + 1) % 4 === 0) {
        return 'col-span-6'
      }
      if ((idx + 1) % 3 === 0) {
        return 'col-span-3'
      }
      if ((idx + 1) % 2 === 0) {
        return 'col-span-6'
      }
      if ((idx + 1) % 1 === 0) {
        return 'col-span-3'
      }
    },

    // Загрузка статей
    onLoadArticles: async function ({ isResetArticles }) {

      const { query } = this.$route

      this.isLoading = true

      // текущий список статей
      let currentArticles = Boolean(isResetArticles) ? [] : [...this.articles]

      // Получение списка статей
      const {
        data: articles,
        headers
      } = await this.$api.agent.transport.get(`promotions?page=${this.pagination.page}`)

      // Устоновка пагинации по данным из API
      const newPagination = {
        page: Number(headers['x-pagination-current-page']),
        perPage: Number(headers['x-pagination-per-page']),
        pageCount: Number(headers['x-pagination-page-count']),
        totalCount: Number(headers['x-pagination-total-count']),
      }

      // Замена данных в url
      this.$router.replace({ query: { page: newPagination.page } })

      // Замена или добавление статей
      this.articles = [...currentArticles, ...articles]
      this.pagination = newPagination

      this.isLoading = false
    },

    // Изменение пагинации (страницы, кол-во на странице и тд)
    onChangePagination: async function ({
      page,
      perPage,
      isResetArticles
    }) {
      let newPagination = { ...this.pagination }
      newPagination['page'] = page || newPagination.page
      newPagination['perPage'] = perPage || newPagination.perPage

      this.pagination = newPagination

      await this.onLoadArticles({ isResetArticles })
    },

    // Открытие статьи
    openArticle: async function ({ slug: articleSlug }) {

      // Получение статьи по SLUG
      const { data: article } = await this.$api.agent.transport.get(`promotions/${articleSlug}?expand=category`)

      // Запись статьи в хранилище
      this.article = Object.assign({}, this.article, {
        ...article,
        category_name: { categoryName: 'Акция' },
        category: { categoryName: 'Акция' },
      })

      // Замена URL при открии стать
      window.history.replaceState(null, null, `/aktsii/${articleSlug}`)

    },
    onCloseArticle: function () {

      this.article = {}

      // Замена URL при закрытии стать
      this.$router.replace('/aktsii')

    },

    nextArticle: async function (lastArticleId, updateRoute) {
      const articles = this.articles
      const component = this.$refs['article-modal']

      const lastArticleIndex = articles.findIndex((t) => Number(t.id) === lastArticleId)
      let article = articles[lastArticleIndex + 1]

      if (!article) {
        if (this.pagination.page >= this.pagination.pageCount) {
          component.isLoadNextArticle = false

          return null
        }

        const articlesLoad = await this.onLoadMore(this.pagination.page + 1, false)
        article = articlesLoad[lastArticleIndex + 1]
      }

      const category = article?.category?.slug || article.category_slug
      const apiRoute = 'promotions'
      const { data: articleResponse } = await this.$api.agent.transport.get(`${apiRoute}/${article.slug}?expand=category`)

      const nextArticle = {
        ...articleResponse,
        apiRoute
      }
      component?.setNextArticle(nextArticle, updateRoute)
    },

    getListAktsii: function (article) {
      if (!article.category_slug) {
        return `/aktsii/${article.slug}`
      }

      return `/aktsii/${article.category_slug}/${article.slug}`
    }
  }

};
